// extracted by mini-css-extract-plugin
module.exports = {"title":"EditHistory-module--title--11aPz MetaItem-module--title--2dHXe","history":"EditHistory-module--history--3EGG9","item":"EditHistory-module--item--2Qpr2"};